module.exports = __webpack_public_path__ + "img/rasterized-gradient-gray-100.cb1b789.png";